// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.stand-by-event .add-event__datepicker,\n.stand-by-event .add-event__timepicker {\n  width: 33.3%;\n  margin: 0;\n  padding: 0 7.5px;\n}\n.stand-by-event .add-event__dates {\n  width: calc(100% + 15px);\n  margin: 0 -7.5px;\n}\n", ""]);
// Exports
module.exports = exports;
